import { useCallback } from 'react';

import { queryClient } from '@/src/lib/react-query/react-query';

import { activityLogsKeys, useActivityLogs } from './api/getActivityLogs';
import { commentsKeys, useComments } from './api/getComments';
import { InfoPaneQueries } from './store/fileEntryViewer.infoPanel.store';

export type useInfoPanelQueriesProps = {
  sourceId: number;
};

export const useInfoPanelQueries = ({ sourceId }: useInfoPanelQueriesProps): InfoPaneQueries => {
  const handleCommentAdded = useCallback(
    (response) => {
      queryClient.setQueryData([...commentsKeys.list(sourceId)], (prev: any) => {
        return {
          ...prev,
          data: [...prev.data, response.data.result],
        };
      });

      queryClient.invalidateQueries([...activityLogsKeys.list(sourceId)]);
    },
    [sourceId]
  );

  return {
    comments: {
      useCommentsQuery: () => useComments({ fileId: sourceId }),
      onCommentAdded: handleCommentAdded,
    },
    useActivityLogsQuery: () => useActivityLogs({ fileId: sourceId }),
  };
};
